import { Button, DialogActions, DialogContent, DialogContentText, TextField } from '@mui/material'
import apiManagerRoom from 'api/manager-meeting'
import DialogBaseCC from 'components/Dialog/DialogBaseCC'
import { DIALOG_ID } from 'components/Dialog/constant'
import { DOMAIN_MEETING } from 'constants/api'
import { NS_TRANS } from 'constants/common'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import theme, { color } from 'theme'
import { handleEnterKeyFunc } from 'utils/functions/common'
import { setCloseDialogCC } from 'utils/helpers'

const DialogMeetingNow = () => {
    const { t } = useTranslation(NS_TRANS.PG_MEETING)
    const [ roomName, setRoomName] = useState(t('pgMeeting:immediatelyRoom'))

    const handleChangeRoomName = (e) => {
        setRoomName(e.target.value)
    }

    const handleJoinNow = async _ => {
        try {
            const res = await apiManagerRoom.joinNow(roomName || t('pgMeeting:immediatelyRoom'))

            if(res.status === 200) {
                window.open(`${DOMAIN_MEETING}/${res.data.roomId}`)
            } 
        } catch (err) {
            console.log("err.", err)
        } finally {
            setCloseDialogCC()
        }
    }

    return (
        <DialogBaseCC id={DIALOG_ID.MEETING_NOW} title={t('popover.titleJoinNow')}>
            <DialogContent>
                <DialogContentText sx={{ color: color.default }}>
                    {t('popover.roomName')}
                </DialogContentText>
                <TextField autoFocus fullWidth placeholder={t('popover.placeholderJoinNow')} value={roomName} onChange={handleChangeRoomName} onKeyPress={(e) => handleEnterKeyFunc(e, handleJoinNow)} sx={{ marginTop: theme.spacing(2.5) }} />
            </DialogContent>
            <DialogActions sx={{ display: 'flex', flexDirection: 'column', rowGap: '1rem', marginTop: '0.5rem' }}>
                <Button onClick={handleJoinNow} sx={{ width: 1, margin: '0 !important' }}>{t('popover.start')}</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogMeetingNow